import { ConfigurationSettingList } from "@kahunmedical/common-configuration/dist/lib/settings";

export const KahunLocalStorageKey = "kahun.v2settings";

export const readV2SettingsFromLocalStorage = () =>
  [
    "localStorage",
    JSON.parse(localStorage.getItem(KahunLocalStorageKey) || "{}"),
  ] as [string, ConfigurationSettingList];
